module.exports = __webpack_public_path__ + "img/pch.4a49cfc3.png";